import {
  NAME_PLACEHOLDER_TOKEN_REGEX,
  WHITESPACE_REGEX,
} from '@/constants/regex';

/**
 * Server-composed full names can leak the literal words "undefined" or "null"
 * when a name part is missing — e.g. a candidate created without a last name
 * (reproducible via the referral flow) comes back as `"Firstname undefined"`.
 *
 * `sanitizeName` drops those stray placeholder tokens and collapses the
 * surrounding whitespace so the UI renders a clean name. See ENG-3433.
 */
export const sanitizeName = (name?: string | null): string => {
  if (!name) return '';

  return name
    .split(WHITESPACE_REGEX)
    .filter((part) => part && !NAME_PLACEHOLDER_TOKEN_REGEX.test(part))
    .join(' ');
};
